import EnhancementsPage from './enhancementsPage.component';

export default EnhancementsPage;